interface IPendingTracking {
  /** Строка запроса выдачи до применения фильтров: с ней сравниваем новую, чтобы получить лейбл */
  queryString: string;
}

interface IPendingClearTag extends IPendingTracking {
  action: 'clearTag';
  /** Счётчик с кнопки, по которой кликнули. У тега он есть всегда */
  count: number;
}

interface IPendingClearAllTags extends IPendingTracking {
  action: 'clearAllTags';
}

export type TPendingEmptyStateTracking = IPendingClearTag | IPendingClearAllTags;

let pendingTracking: TPendingEmptyStateTracking | null = null;

/**
 * События по тегам пустой выдачи нельзя отправить прямо в момент клика: в лейбле нужны снятые
 * параметры запроса, а новая строка запроса приезжает только вместе с обновлённой выдачей.
 * Поэтому клик откладывает сюда всё, что известно на месте, а событие уходит после того,
 * как микрофронт фильтров применил jsonQuery и выдача перезапросилась.
 */
export function setPendingEmptyStateTracking(value: TPendingEmptyStateTracking): void {
  pendingTracking = value;
}

export function takePendingEmptyStateTracking(): TPendingEmptyStateTracking | null {
  const value = pendingTracking;

  pendingTracking = null;

  return value;
}
